import { render, staticRenderFns } from "./inventory-filter.vue?vue&type=template&id=1193c6cc"
import script from "./inventory-filter.vue?vue&type=script&lang=js"
export * from "./inventory-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports